export default __webpack_public_path__ + "static/media/4. Post Visit Patient Reflection.555f71ba.wav";